<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">
      <mrsoftapps-register-gmou
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [gmous]="gmou$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (taskEmit)="taskEvent($event)"
      *ngIf="
      !(isLoadingGmou$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async)

"
      >


      </mrsoftapps-register-gmou>

    </ng-template>

  </div>



<mrsoftapps-epims-reference-spinner
*ngIf="
(isLoadingGmou$ | async) ||
(isLoadingState$ | async) ||
(isLoadingLga$ | async) ||
(isLoadingProjectType$ | async) ||
(isLoadingProjectCategory$ | async) ||
(isLoadingOilBlock$ | async) ||
(isLoadingOilField$ | async)
"


></mrsoftapps-epims-reference-spinner>
</main>
</div>
</dashboardnav>
